/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RodzajTyp {
  Decyzja = 'DECYZJA',
  Wniosek = 'WNIOSEK',
  Pismo = 'PISMO',
  Inny = 'INNY'
}
